import script from "./FeedView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedView.vue?vue&type=script&lang=ts&setup=true"

import "./FeedView.vue?vue&type=style&index=0&id=693fab8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693fab8d"]])

export default __exports__